export const checkPermission = (permission, type, name, slug) => {
  // return true
  let module_key = name?.replaceAll(" ", "_").toLowerCase();
  if (
    module_key === "logout" ||
    module_key === "my_profile" ||
    module_key === "reset_password" ||
    module_key === "safety_information"
  ) {
    return true;
  }
  let keys = ["edit", "add", "duplicate", "events", "view"];
  if (slug) {
    if (slug === "/") return true;
    let isAllowed = { value: true };
    let treeData = permission?.permission_json;
    let dataArray = slug.split("/");
    const index = dataArray.indexOf("edit");
    if (index !== -1) {
      dataArray = dataArray.slice(0, index); // keep only before "edit"
    }
    dataArray = dataArray.filter(
      (item) => !keys.includes(item) && item !== "" && !parseInt(item) > 0
    );

    if (treeData) permissionCheck(treeData, dataArray, isAllowed, 0, type);

    return isAllowed?.value;
  }

  return permission?.[type]?.includes(module_key);
};

const permissionCheck = (permission, key, isAllowed, index, type) => {
  let dataType =
    type == "read_per"
      ? "read"
      : type == "create_per"
      ? "write"
      : type == "update_per"
      ? "edit"
      : type == "delete_per"
      ? "delete"
      : type == "download_per" && "download";
  isAllowed.value = permission?.find(
    (item) => item.key == `/${key[index]}`
  )?.permissions?.[dataType];

  if (key?.[index + 1]) {
    permissionCheck(
      permission?.find((item) => item.key == `/${key[index]}`)?.children,
      key,
      isAllowed,
      index + 1,
      type
    );
  }
};
